<template>
  <div class="editable-table" :class="{ 'edit-border': mode == 'edit', 'is-edit': mode == 'edit' }">
    <div class="table-title" v-if="!data.isHideTitle">
      <text-box
        type="editor"
        position="topRight"
        :mode="mode"
        :image-style="{ height: '22px' }"
        :value="data.title || '表格标题'"
        @onChange="handleTitleChange"
      >
        {{ data.title || "表格标题" }}
      </text-box>
    </div>
    <table>
      <thead v-if="!data.isHideTHead">
        <tr>
          <th
            v-for="(item, colIndex) in data.head"
            :key="colIndex"
            :data-col="colIndex"
            :data-row="-1"
            :style="{ textAlign: data.colStyle[colIndex].align }"
            @contextmenu.prevent.stop="mode === 'edit' && handleTableContextmenu($event, colIndex, -1)"
          >
            <text-box
              type="editor"
              :mode="mode"
              :value="item"
              :image-style="{ height: '22px' }"
              @onChange="value => hanldeCellChange(colIndex, -1, value)"
            >
              <span style="white-space: pre-wrap;">{{ item || "表头" }}</span>
            </text-box>
          </th>
        </tr>
      </thead>
      <tbody v-if="!data.isHideTBody">
        <tr v-for="(row, rowIndex) in data.body" :key="rowIndex">
          <td
            v-for="(cell, cellIndex) in row"
            :key="cellIndex"
            :data-col="cellIndex"
            :data-row="rowIndex"
            :style="{ textAlign: data.colStyle[cellIndex].align }"
            @contextmenu.prevent.stop="mode === 'edit' && handleTableContextmenu($event, cellIndex, rowIndex)"
          >
            <text-box
              type="editor"
              :mode="mode"
              :value="cell"
              :image-style="{ height: '25px' }"
              @onChange="value => hanldeCellChange(cellIndex, rowIndex, value)"
            >
              <span style="white-space: pre-wrap;">{{ cell || "单元格" }}</span>
            </text-box>
          </td>
        </tr>
      </tbody>
    </table>
    <div ref="controlPanel" class="control-panel">
      <div class="panel-item" @click.stop="handleContextMenu('deleteColumn')">
        删除当前列
      </div>
      <div class="panel-item" @click.stop="handleContextMenu('addColumn')">
        在后方添加一列
      </div>
      <div v-if="!hideRowMenu" class="panel-item" @click.stop="handleContextMenu('deleteRow')">
        删除当前行
      </div>
      <div class="panel-item" @click.stop="handleContextMenu('addRow')">
        在后方添加一行
      </div>
      <div class="panel-item has-next">
        对齐方式
        <div class="next-control-panel">
          <div class="panel-item" @click="handleContextMenu('align:left')">
            左对齐
          </div>
          <div class="panel-item" @click="handleContextMenu('align:center')">
            居中对齐
          </div>
          <div class="panel-item" @click="handleContextMenu('align:right')">
            右对齐
          </div>
        </div>
      </div>
    </div>
    <div class="edit-btns" v-if="mode == 'edit'">
      <button class="btn setup-btn" @click.stop="handleSetup">
        <i class="icon wiki-editable-setup"></i>
      </button>
      <button class="btn delete-btn" @click.stop="handleDelete">
        <i class="icon wiki-editable-delete"></i>
      </button>
      <button class="btn add-btn" @click.stop="handleAdd">
        <i class="icon wiki-editable-add"></i>
      </button>
    </div>
    <!-- 设置 -->
    <setup-panel ref="setupPanel" :data="data" @onChange="handleSetupPannelChange"></setup-panel>
  </div>
</template>

<script>
// components
import TextBox from "../TextBox";
import SetupPanel from "./SetupPanel.vue";
// plugins
import { throttle } from "@/plugins/util";

export default {
  name: "EditableTable",
  components: {
    TextBox,
    SetupPanel
  },
  props: {
    mode: String,
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      hideRowMenu: false,
      currentCellPosition: [0, 0]
    };
  },
  watch: {},
  mounted() {
    if (this.mode === "edit") {
      window.addEventListener("click", this.clickOtherArea);
      document.getElementById("illustratedBookEdit").addEventListener("scroll", this.onScroll);
    }
  },
  beforeDestroy() {
    window.removeEventListener("click", this.clickOtherArea);
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    // 添加表格
    handleAdd() {
      this.$emit("onAdd");
    },
    // 删除表格
    handleDelete() {
      this.$emit("onDelete");
    },
    // 表格设置
    handleSetup() {
      this.$refs.setupPanel.open();
    },
    handleSetupPannelChange(data) {
      this.$emit("onChange", data);
    },
    // 表格标题
    handleTitleChange(title) {
      const data = this.data;
      data.title = title;
      this.$emit("onChange", data);
    },
    // 页面滚动时
    onScroll: throttle(function(e) {
      const controlPanelDom = this.$refs ? this.$refs.controlPanel : null;
      if (controlPanelDom && controlPanelDom.parentNode == document.body) {
        document.body.removeChild(controlPanelDom);
      }
    }, 200),
    // 点击非表格右键菜单，其他区域时
    clickOtherArea(e) {
      const controlPanelDom = this.$refs ? this.$refs.controlPanel : null;
      if (controlPanelDom && controlPanelDom.parentNode == document.body) {
        document.body.removeChild(controlPanelDom);
      }
    },
    // 表格中右键
    handleTableContextmenu(e, colIndex, rowIndex) {
      // console.log(e);
      const controlPanelDom = this.$refs.controlPanel;
      // 添加到最上层，规避container 设置transform导致定位错误
      document.body.appendChild(controlPanelDom);
      // console.log(controlPanelDom.style);
      controlPanelDom.style.left = e.pageX + "px";
      controlPanelDom.style.top = e.pageY + "px";
      if (parseInt(rowIndex) == -1) {
        this.hideRowMenu = true;
      } else {
        this.hideRowMenu = false;
      }
      this.currentCellPosition = [parseInt(colIndex), parseInt(rowIndex)];
    },
    // 执行菜单函数
    handleContextMenu(type) {
      const controlPanelDom = this.$refs ? this.$refs.controlPanel : null;
      const [colIndex, rowIndex] = this.currentCellPosition;

      if (controlPanelDom && controlPanelDom.parentNode == document.body) {
        document.body.removeChild(controlPanelDom);
      }
      switch (type) {
        case "deleteColumn":
          this.handleColumnDelete(colIndex);
          break;
        case "addColumn":
          this.handleColumnAdd(colIndex);
          break;
        case "deleteRow":
          this.handleRowDelete(rowIndex);
          break;
        case "addRow":
          this.handleRowAdd(rowIndex);
          break;
        case "align:left":
          this.handleColumnAlign("left", colIndex, rowIndex);
          break;
        case "align:center":
          this.handleColumnAlign("center", colIndex, rowIndex);
          break;
        case "align:right":
          this.handleColumnAlign("right", colIndex, rowIndex);
          break;
        default:
          console.lof("no type");
      }
    },
    // 列对齐
    handleColumnAlign(type, colIndex) {
      const data = this.data;
      data.colStyle.splice(colIndex, 1, {
        align: type
      });
      this.$emit("onChange", { ...data, key: Math.random().toString(16) });
    },
    // 单元格change
    hanldeCellChange(colIndex, rowIndex, value) {
      const data = this.data;
      if (rowIndex == -1) {
        data.head.splice(colIndex, 1, value);
      } else {
        data.body.forEach((row, index) => {
          if (rowIndex === index) {
            row.splice(colIndex, 1, value);
          }
        });
      }
      this.$emit("onChange", data);
    },
    // 列删除
    handleColumnDelete(colIndex) {
      const data = this.data;
      if (data.head.length === 1) {
        this.$alert("最后一列不能删除!");
        return;
      }
      data.colStyle.splice(colIndex, 1);
      data.head.splice(colIndex, 1);
      data.body.forEach(row => {
        row.splice(colIndex, 1);
      });
      this.$emit("onChange", { ...data, key: Math.random().toString(16) });
    },
    // 列添加
    handleColumnAdd(colIndex) {
      const data = this.data;
      data.colStyle.splice(colIndex + 1, 0, { align: "left" });
      data.head.splice(colIndex + 1, 0, "");
      data.body.forEach(row => {
        row.splice(colIndex + 1, 0, "");
      });
      this.$emit("onChange", { ...data, key: Math.random().toString(16) });
    },
    // 行删除
    handleRowDelete(rowIndex) {
      const data = this.data;
      data.body.splice(rowIndex, 1);
      this.$emit("onChange", { ...data, key: Math.random().toString(16) });
    },
    // 行添加
    handleRowAdd(rowIndex) {
      const data = this.data;
      let arr = [];
      for (let i = 0; i < data.head.length; i++) {
        arr[i] = "";
      }
      data.body.splice(rowIndex + 1, 0, arr);
      this.$emit("onChange", { ...data, key: Math.random().toString(16) });
    }
  }
};
</script>

<style lang="less" scoped>
// 变量
@table-border-color: #727c86;

.is-edit {
  &:hover {
    outline: #c7ccd5;
    outline-style: solid;
    outline-width: 3px;
    .edit-btns {
      display: flex;
    }
  }
}

.edit-btns {
  display: none;
  position: absolute;
  height: 20px;
  right: -69px;
  top: 0px;
  padding-bottom: 3px;
  .btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 3px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    &:hover {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
.editable-table {
  position: relative;
  padding: 4px;

  .table-title {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: bold;
    color: #373737;
    line-height: 22px;
  }
  thead {
    height: 22px;
    th {
      min-width: 40px;
      height: 32px;
      line-height: 22px;
      position: relative;
      font-size: 14px;
      font-weight: 400;
      color: #373737;
      text-align: left;
      &:hover {
        // background-color: #c7ccd5;
        .column-btns {
          display: inline-flex;
        }
      }
    }
  }

  tbody {
    tr {
      height: 35px;
      position: relative;
      &:hover {
        // background-color: #c7ccd5;
        .row-btns {
          display: inline-flex;
        }
      }
    }
    td {
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      font-weight: 400;
      color: #373737;
      line-height: 22px;
    }
  }

  .btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 3px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    &:hover {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }

  .column-btns {
    display: none;
    position: absolute;
    height: 23px;
    right: 0;
    top: -23px;
    padding-bottom: 3px;
  }

  .row-btns {
    display: none;
    position: absolute;
    height: 20px;
    right: -43px;
    top: 0px;
    padding-bottom: 0px;
  }
}
.edit-border {
  table,
  th,
  td {
    border: 1px dotted @table-border-color;
    border-collapse: collapse;
  }
}

.add-btn {
  width: 20px;
  height: 20px;
  color: #ffffff;
  border-radius: 4px;
  margin-left: 3px;
  border: none;
  vertical-align: middle;
  line-height: 20px;
  text-align: center;
  &:hover {
    opacity: 0.9;
  }
  .icon {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}

.control-panel {
  position: fixed;
  z-index: 100;
  top: -1000px;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 150px;
  height: auto;
  min-height: 64px;
  border-radius: 4px;
  border: 1px solid #e3e3e3;
  box-shadow: 1px 2px 5px 2px rgba(0, 0, 0, 0.2);

  .has-next {
    position: relative;
    &:hover {
      .next-control-panel {
        display: flex;
      }
    }
  }
  .next-control-panel {
    display: none;
    position: absolute;
    flex-direction: column;
    background-color: #ffffff;
    width: 120px;
    height: auto;
    right: -120px;
    top: 0;
    border-radius: 4px;
    border: 1px solid #e3e3e3;
    box-shadow: 1px 2px 5px 2px rgba(0, 0, 0, 0.2);
  }

  .panel-item {
    width: 100%;
    color: #333;
    height: 32px;
    padding: 0 20px;
    line-height: 32px;
    border-bottom: 1px solid #e3e3e3;
    cursor: pointer;
    &:hover {
      background-color: #e3e3e3;
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
